import hljs from "highlight.js/lib/core"
import bash from "highlight.js/lib/languages/bash"
import csharp from "highlight.js/lib/languages/csharp"
import dockerfile from "highlight.js/lib/languages/dockerfile"
import ini from "highlight.js/lib/languages/ini"
import javascript from "highlight.js/lib/languages/javascript"
import json from "highlight.js/lib/languages/json"
import plaintext from "highlight.js/lib/languages/plaintext"
import ruby from "highlight.js/lib/languages/ruby"
import sql from "highlight.js/lib/languages/sql"
import typescript from "highlight.js/lib/languages/typescript"
import xml from "highlight.js/lib/languages/xml"
import yaml from "highlight.js/lib/languages/yaml"
import { createHighlightJsAdapter } from "@mantine/code-highlight"

// "plaintext" MUST be registered: Mantine's highlight.js adapter substitutes
// it for any language this core build does not know, and hljs.highlight throws
// "Unknown language" for an unregistered one — which unmounted the whole SPA
// the first time a guide with a ```text fence (the BTCPay reference) rendered
// in the browser. Registering it makes every unknown fence degrade to plain
// text instead of a crash.
hljs.registerLanguage("plaintext", plaintext)
hljs.registerLanguage("text", plaintext)
hljs.registerLanguage("txt", plaintext)
hljs.registerLanguage("bash", bash)
hljs.registerLanguage("sh", bash)
hljs.registerLanguage("shell", bash)
hljs.registerLanguage("dotenv", bash)
hljs.registerLanguage("ini", ini)
hljs.registerLanguage("toml", ini)
hljs.registerLanguage("systemd", ini)
hljs.registerLanguage("javascript", javascript)
hljs.registerLanguage("js", javascript)
hljs.registerLanguage("json", json)
hljs.registerLanguage("ruby", ruby)
hljs.registerLanguage("rb", ruby)
hljs.registerLanguage("typescript", typescript)
hljs.registerLanguage("ts", typescript)
hljs.registerLanguage("tsx", typescript)
hljs.registerLanguage("jsx", javascript)
hljs.registerLanguage("xml", xml)
hljs.registerLanguage("html", xml)
hljs.registerLanguage("erb", xml)
hljs.registerLanguage("yaml", yaml)
hljs.registerLanguage("yml", yaml)
// The rest of the fence languages the published guides use today.
hljs.registerLanguage("sql", sql)
hljs.registerLanguage("dockerfile", dockerfile)
hljs.registerLanguage("docker", dockerfile)
hljs.registerLanguage("csharp", csharp)
hljs.registerLanguage("cs", csharp)

export const highlightJsAdapter = createHighlightJsAdapter(hljs)

export const codeLanguage = (raw?: string | null): string => {
  const value = (raw || "text").toLowerCase()
  if (value === "ts" || value === "tsx") return "typescript"
  if (value === "js" || value === "jsx") return "javascript"
  if (value === "rb") return "ruby"
  if (value === "sh" || value === "shell" || value === "dotenv" || value === "env") return "bash"
  if (value === "yml") return "yaml"
  if (value === "toml" || value === "systemd") return "ini"
  if (value === "txt" || value === "plaintext") return "text"
  if (value === "cs") return "csharp"
  if (value === "docker") return "dockerfile"
  return value
}
